<rask-page
    pageTitle="{{ texts.sokProdukt }}"
    [actionShow]="canCreate()"
    [actionFn]="create"
    actionTitle="{{ texts.skapaNyProdukt }}"
    noPadding>
    <ng-container headerContent>
        <rask-produkt-search-panel (searchresult)="onResult($event)"></rask-produkt-search-panel>
    </ng-container>
    <rask-produkt-search-result [results]="results"></rask-produkt-search-result>
</rask-page>